var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctoral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01575 9C6.534 9 4.51575 6.98175 4.51575 4.5C4.51575 2.01825 6.53475 0 9.01575 0C11.4968 0 13.5158 2.01825 13.5158 4.5C13.5158 6.98175 11.4975 9 9.01575 9ZM10.5 13.638V10.5H6.73425V13.7078C7.1805 13.9672 7.48425 14.4458 7.48425 15C7.48425 15.8287 6.813 16.5 5.98425 16.5C5.1555 16.5 4.48425 15.8287 4.48425 15C4.48425 14.4465 4.788 13.968 5.23425 13.7078V10.5015C3.174 10.5105 1.5 12.1875 1.5 14.25V18H9V15.75C9 14.7735 9.62925 13.9485 10.5 13.638ZM12.75 10.5H12V13.638C12.8708 13.9485 13.5 14.7735 13.5 15.75V18H16.5V14.25C16.5 12.1823 14.8178 10.5 12.75 10.5ZM11.25 15C10.836 15 10.5 15.336 10.5 15.75V18H12V15.75C12 15.336 11.664 15 11.25 15Z",
    fill: "url(#paint0_linear_268_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_49",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctoral);
export default __webpack_public_path__ + "static/media/doctoral.c3e0af1a36dc15c8803ae4f75ac89525.svg";
export { ForwardRef as ReactComponent };